import {IMapper} from "../i-mapper";
import {IApplicationSettingsDropdownField, IApplicationSettingsOption} from "@zaeper/angular-application-store-lib";
import {InputSelection, ISelectionOption} from "@zaeper/angular-dashboard-view-lib";
import {FormControl, FormGroup} from "@angular/forms";

export class ApplicationSettingsDropdownFieldMapper implements Partial<IMapper<IApplicationSettingsDropdownField, InputSelection>> {
  constructor(private readonly _formGroup: FormGroup) {
  }

  from(applicationSettingsDropdownField: IApplicationSettingsDropdownField): InputSelection {
    const formControl: FormControl<string | null> = new FormControl(applicationSettingsDropdownField.defaultValue ?? null);

    this._formGroup.setControl(applicationSettingsDropdownField.id, formControl);

    const selections: ISelectionOption[] = applicationSettingsDropdownField.items.map((option: IApplicationSettingsOption): ISelectionOption => ({
      title: option.value,
      value: option.id
    }));

    return new InputSelection({
      formControlEntry: {
        formControl: formControl, key: applicationSettingsDropdownField.id
      },
      title: applicationSettingsDropdownField.label.de,
      inputId: applicationSettingsDropdownField.id,
      required: applicationSettingsDropdownField.required ?? false,
      placeholder: applicationSettingsDropdownField.placeholder?.de,
      selections: selections
      // TODO Phase 3: honor `description` + `compact`. Dev-tool may carry per-item localized label — currently only raw `value` is shown.
    });
  }
}
